import Rest from '@/services/Rest';

export default class MetaService extends Rest {
  static resource = 'site/meta';
}
